import AllSomeBanner from '$lib/AllSomeBanner.svelte';
import CourseBanner from '$lib/CourseBanner.svelte';
import WorksheetBanner from '$lib/WorksheetBanner.svelte';
import Bundle from '$lib/Bundle.svelte';

const COMPONENTS = {
    allsome: AllSomeBanner,
    course: CourseBanner,
    worksheet: WorksheetBanner,
    bundle: Bundle
};

const PROP_NAMES = {
    course: 'course',
    worksheet: 'worksheet',
    bundle: 'bundle'
};

export function get_banner_render(banner) {
    return {
        component: COMPONENTS[banner.product_type],
        prop_name: PROP_NAMES[banner.product_type] || banner.product_type,
        props:
            banner.product_type === 'allsome'
                ? {}
                : {
                      [PROP_NAMES[banner.product_type]]: banner.product,
                      title: banner.title,
                      lead: banner.lead
                  }
    };
}

export function make_banner_at(resolved_banners, { first = 2, step = 9 } = {}) {
    return function banner_at(index) {
        const banner_index = (index - first) / step;
        if (!Number.isInteger(banner_index) || banner_index < 0) return null;
        const banner = resolved_banners[banner_index];
        return banner ? get_banner_render(banner) : null;
    };
}
